import { useQuery } from "@tanstack/react-query";

import { getDairyHerdSize } from "services";

import { DEFAULT_CACHE_TIME, GET_DAIRY_HERD_SIZE } from "consts";

import { FootprintingDairyHerdSize } from "models";

export const useGetFootprintingDairyHerdSize = (primaryDataId: string, options?: { enabled?: boolean }) =>
  useQuery<FootprintingDairyHerdSize[]>({
    queryKey: [GET_DAIRY_HERD_SIZE, primaryDataId],
    queryFn: () => getDairyHerdSize(primaryDataId),
    enabled: options?.enabled !== false && !!primaryDataId,
    gcTime: DEFAULT_CACHE_TIME,
    staleTime: DEFAULT_CACHE_TIME,
  });
